import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { BaseUserAdsComponent } from '~app/user-ads/abstract-components/base-user-ads.component';
import { UserAdsCreationDialogComponent } from '~app/user-ads/modals/user-ads-creation-dialog/user-ads-creation-dialog.component';

@Component({
  selector: 'user-ads-datatable',
  standalone: false,
  templateUrl: './user-ads-datatable.component.html',
  styleUrl: './user-ads-datatable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserAdsDatatableComponent extends BaseUserAdsComponent {
  private _dialogService = inject(DialogService);
  displayedColumns: string[] = [
    'name',
    'media',
    'support',
    'timeSlot',
    'broadcastDate'
  ];

  dataSource = [
    {
      name: 'Canal+',
      media: 'Télévision',
      support: 'Affiche',
      timeSlot: '18:00 - 19:00',
      broadcastDate: '12/02/2024'
    },
    {
      name: 'Orange',
      media: 'Radio',
      support: 'Spot',
      timeSlot: '08:00 - 09:00',
      broadcastDate: '15/03/2024'
    }
  ];

  openAddDialog(): void {
    this._dialogService.open({
      component: UserAdsCreationDialogComponent,
      fullscreen: true
    });
  }
}
